import { useState, useEffect } from "react";
import { fetchOnePiecePrices } from "../../shared";

/**
 * Market prices for a set of One Piece cards, keyed by card code.
 *
 * A code maps to null when its exact print isn't in the upstream catalogue —
 * the two sources number parallels differently, and the prints of one card can
 * differ by hundreds of dollars, so an unmatched card shows nothing rather than
 * another print's price.
 */
export default function useOnePiecePrices(cards) {
  const [prices, setPrices] = useState({});
  const [state, setState] = useState("idle");

  // Join the codes so the effect only re-runs when the set of cards changes,
  // not on every re-render of the list.
  const key = (cards || []).map((c) => c.number || c.code || "").filter(Boolean).sort().join(",");

  useEffect(() => {
    if (!key) { setPrices({}); setState("idle"); return undefined; }
    let cancelled = false;
    setState("loading");
    fetchOnePiecePrices(key.split(","))
      .then((p) => { if (!cancelled) { setPrices(p); setState("ready"); } })
      .catch(() => { if (!cancelled) setState("error"); });
    return () => { cancelled = true; };
  }, [key]);

  return { prices, state };
}
